import React, { CSSProperties, FC, Fragment } from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';

import { useContent } from 'hooks';

import { ImageType } from 'features/content/widgets/Images/types';
import Renderer from 'features/content/widgets/Images/Renderer';

const styles = {
  P80: {
    paddingTop: '80%',
  },
  P100: {
    paddingTop: '100%',
  },
  P140: {
    paddingTop: '140%',
  },
} as const;

interface RendererOptions {
  index: number;
  rootClass: CSSProperties;
  autoShrink: boolean;
}

const PostCardImages: FC = () => {
  const content = useContent();

  const { content_object } = content;
  const { url_metadata, photos } = content_object;

  const imageList = getImages();

  function getImages() {
    const list: Array<ImageType> = [];

    if (photos?.length) {
      list.push(...photos);
      return list;
    }

    url_metadata?.images?.length && list.push(url_metadata?.images[0]);
    return list;
  }

  function renderImage({ index, rootClass, autoShrink }: RendererOptions) {
    const image = imageList[index];
    const commonProps = {
      onClick: () => null as any,
      disableViewer: true,
      classes: {
        root: rootClass,
        image: {},
      },
      autoShrink,
      image,
    };

    if ('key' in image) {
      return <Renderer filePathKey="key" {...commonProps} />;
    }

    if ('file_key' in image) {
      return <Renderer filePathKey="file_key" {...commonProps} />;
    }

    throw new Error('The Images component encountered an unknown object type');
  }

  function renderOne() {
    return (
      <Fragment>{renderImage({ index: 0, rootClass: styles.P100, autoShrink: false })}</Fragment>
    );
  }

  function renderTwo() {
    return (
      <Grid container>
        <Grid xs={6}>{renderImage({ index: 0, rootClass: styles.P140, autoShrink: true })}</Grid>
        <Grid xs={6}>{renderImage({ index: 1, rootClass: styles.P140, autoShrink: true })}</Grid>
      </Grid>
    );
  }

  function renderThree() {
    return (
      <Fragment>
        <Grid container>
          <Grid xs>{renderImage({ index: 0, rootClass: styles.P80, autoShrink: true })}</Grid>
        </Grid>
        <Grid container>
          <Grid xs={6}>{renderImage({ index: 1, rootClass: styles.P100, autoShrink: false })}</Grid>
          <Grid xs={6}>{renderImage({ index: 2, rootClass: styles.P100, autoShrink: false })}</Grid>
        </Grid>
      </Fragment>
    );
  }

  switch (imageList.length) {
    case 1:
      return renderOne();
    case 2:
      return renderTwo();
    case 3:
      return renderThree();
    case 4:
      return renderThree();
    case 5:
      return renderThree();
    default:
      return null;
  }
};

export default PostCardImages;
